/* @flow */

import React from 'react';
import { TEXT_CHARACTER_LIMIT } from 'edito/constants/index';
import { getCharCount, getLineCount, getWordCount } from 'utils/richtext';
import { Segment } from 'semantic-ui-react';

type Props = {
  editorState: object,
  charLimit?: number,
  chars?: boolean,
  lines?: boolean,
  words?: boolean,
};

const CharacterCount = ({
  editorState,
  charLimit,
  chars,
  lines,
  words,
}: Props) => {
  const count = getCharCount(editorState);
  const charCountClassname = count > (charLimit || TEXT_CHARACTER_LIMIT)
    ? { color: 'rgb(255, 0, 0)' }
    : { color: 'inherit' };

  const renderChars =
    chars &&
    <div>
      Nombre de caractères: <span style={charCountClassname}>{count}</span>
    </div>;
  const renderLines =
    lines &&
    <div>Nombre de lignes: <span>{getLineCount(editorState)}</span></div>;
  const renderWords =
    words &&
    <div>Nombre de mots: <span>{getWordCount(editorState)}</span></div>;

  return (
    <Segment compact>
      {renderLines}
      {renderWords}
      {renderChars}
    </Segment>
  );
};

export default CharacterCount;



// WEBPACK FOOTER //
// ./src/shared/components/RichTextCounter.js